/* PDP image zoom. Markup in snippets/product-zoom.liquid, styles in product-zoom.css */
(function () {
  function init() {
    var overlay = document.getElementById('ProductZoom');
    var gallery = document.querySelector('.product__images .slider__container');
    if (!overlay || !gallery || overlay.dataset.ready) return;
    overlay.dataset.ready = 'true';

    // Fixed layers must sit on <body> so no transformed ancestor can trap them
    var cursorEl = document.querySelector('.js-pzCursor');
    document.body.appendChild(overlay);
    if (cursorEl) document.body.appendChild(cursorEl);

    var stage = overlay.querySelector('.js-pzStage');
    var images = Array.prototype.slice.call(overlay.querySelectorAll('.js-pzImg'));
    var closeBtn = overlay.querySelector('.js-pzClose');
    var prevBtn = overlay.querySelector('.js-pzPrev');
    var nextBtn = overlay.querySelector('.js-pzNext');
    var count = overlay.querySelector('.js-pzCount');
    var cursor = document.querySelector('.js-pzCursor');
    var closeMark = overlay.querySelector('.js-pzCloseMark');
    var canHover = window.matchMedia('(hover: hover) and (min-width: 1024px)');

    if (!images.length) return;

    // Gallery items that hold an image, in the same order as the overlay images
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__image')).filter(function (item) {
      return item.querySelector('img') && !item.querySelector('video');
    });
    items.forEach(function (item, i) {
      if (i >= images.length) return;
      item.classList.add('pz-zoomable');
      item.dataset.zoomIndex = i;
    });

    var current = 0;
    var lastItem = null;
    var down = null;
    var lastX = 0;
    var lastY = 0;
    var spinBack = null;

    // Show the gallery's already-loaded image at once, then swap in the 3000px file when it arrives
    function load(i) {
      var img = images[i];
      if (!img || img.dataset.loading) return;
      img.dataset.loading = 'true';
      var small = items[i] && items[i].querySelector('img');
      if (small && (small.currentSrc || small.src)) img.src = small.currentSrc || small.src;
      var full = new Image();
      full.onload = function () { img.src = img.dataset.src; };
      full.src = img.dataset.src;
    }

    function show(i, ratioX, ratioY) {
      current = (i + images.length) % images.length;
      images.forEach(function (img, n) { img.hidden = n !== current; });
      load(current);
      load((current + 1) % images.length);
      load((current - 1 + images.length) % images.length);
      count.textContent = images.length > 1 ? (current + 1) + ' / ' + images.length : '';
      prevBtn.hidden = nextBtn.hidden = images.length < 2;
      requestAnimationFrame(function () {
        overlay.scrollTop = (ratioY || 0) * (overlay.scrollHeight - overlay.clientHeight);
        overlay.scrollLeft = (ratioX == null ? 0.5 : ratioX) * (overlay.scrollWidth - overlay.clientWidth);
      });
    }

    function open(i, ratioX, ratioY) {
      overlay.hidden = false;
      document.body.classList.add('pz-open');
      show(i, ratioX, ratioY);
      closeBtn.focus({ preventScroll: true });
      // Spin the + into the x: cursor straight away, close button on the next frame
      clearTimeout(spinBack);
      if (cursor) cursor.classList.remove('is-back');
      setCursor(true, true);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { closeMark.classList.add('pz__mark--x'); });
      });
    }

    function close() {
      overlay.hidden = true;
      document.body.classList.remove('pz-open');
      closeMark.classList.remove('pz__mark--x');
      // Spin the x back into the + where the pointer is, then settle on whatever is under it
      setCursor(true, false);
      if (cursor) cursor.classList.add('is-back');
      clearTimeout(spinBack);
      spinBack = setTimeout(function () {
        if (cursor) cursor.classList.remove('is-back');
        var under = document.elementFromPoint(lastX, lastY);
        setCursor(!!(under && under.closest('.pz-zoomable')), false);
      }, 650);
      if (lastItem) lastItem.focus({ preventScroll: true });
    }

    function setCursor(visible, isClose) {
      if (!cursor) return;
      cursor.classList.toggle('is-visible', !!visible && canHover.matches);
      cursor.classList.toggle('is-close', !!isClose);
    }

    function moved(e) {
      return !down || Math.abs(e.clientX - down.x) > 8 || Math.abs(e.clientY - down.y) > 8;
    }

    // Open from the gallery. Touch opens on the tap itself (pointerup), because phones
    // (iOS Safari especially) and the gallery swiper do not reliably send a click.
    // Mouse opens on click. A swipe or drag does not count as a tap.
    var tap = null;
    var skipClick = false;

    function openFrom(item, x, y) {
      lastItem = item;
      var box = item.getBoundingClientRect();
      open(Number(item.dataset.zoomIndex), (x - box.left) / box.width, (y - box.top) / box.height);
    }

    gallery.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY };
      tap = { item: e.target.closest('.pz-zoomable'), type: e.pointerType, time: Date.now() };
    }, true);

    // Listen on document: the swiper may capture the pointer, so pointerup can land outside the gallery
    document.addEventListener('pointerup', function (e) {
      if (!tap || !tap.item || tap.type === 'mouse' || !overlay.hidden) return;
      if (moved(e) || Date.now() - tap.time > 600) return;
      skipClick = true;
      setTimeout(function () { skipClick = false; }, 700);
      var item = tap.item;
      tap = null;
      openFrom(item, e.clientX, e.clientY);
    }, true);

    gallery.addEventListener('click', function (e) {
      if (skipClick) return;
      var item = e.target.closest('.pz-zoomable') || (tap && tap.item);
      if (!item || moved(e)) return;
      e.preventDefault();
      openFrom(item, e.clientX, e.clientY);
    });

    items.forEach(function (item) {
      if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
      item.setAttribute('aria-label', 'Zoom image');
      item.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        lastItem = item;
        open(Number(item.dataset.zoomIndex), 0.5, 0);
      });
    });

    // Cursor: brand + over the gallery, brand x inside the overlay
    document.addEventListener('mousemove', function (e) {
      if (!cursor) return;
      cursor.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
      lastX = e.clientX;
      lastY = e.clientY;
      if (cursor.classList.contains('is-back')) return;
      var onButton = e.target.closest('.pz__close, .pz__arrow, .pz__count');
      if (!overlay.hidden) {
        setCursor(!onButton, true);
      } else {
        setCursor(!!e.target.closest('.pz-zoomable'), false);
      }
    });

    document.addEventListener('mouseleave', function () { setCursor(false); });

    // Inside the overlay a click closes on desktop; on touch screens only the x closes
    stage.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY };
    });
    stage.addEventListener('click', function (e) {
      if (skipClick) return; // the click a tap generates after it opened the zoom
      if (canHover.matches && !moved(e)) close();
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(current - 1, 0.5, 0); });
    nextBtn.addEventListener('click', function () { show(current + 1, 0.5, 0); });

    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1, 0.5, 0);
      if (e.key === 'ArrowRight') show(current + 1, 0.5, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
